<template v-if="datosCotizacion">
  <div id="section--datos">
    <section>
      <div class="card card-custom">
        <div class="card-body">
          <div class="d-flex flex-wrap">
            <div class="col-md-12">
              <h4 class="mt-4 mb-3 title-custom">Datos Generales</h4>
            </div>
          </div>

          <div class="d-flex flex-wrap mt-3">
            <div class="col-md-6">
              <p>
                <span class="title-custom">Asegurado: </span>
                {{ datosPoliza.ASEGURADO[0].NOMBRE }}
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <span class="title-custom">Número de Póliza: </span>
                {{ datosPoliza.NUMPOLIZA }}
              </p>
            </div>
          </div>

          <div class="d-flex flex-wrap">
            <div class="col-md-12">
              <hr />
            </div>
          </div>

          <div
            class="d-flex flex-wrap mt-3"
            v-if="typeEndoso !== 8 && typeEndoso !== 9"
          >
            <div class="col-md-4">
              <p>
                <span class="title-custom">Inicio de la vigencia </span>
                {{ datosPoliza.INIVIGENCIA }}
              </p>
            </div>
            <div class="col-md-4">
              <p>
                <span class="title-custom">Fin de la vigencia </span>
                {{ datosPoliza.FINVIGENCIA }}
              </p>
            </div>
            <div class="col-md-4">
              <p>
                <span class="title-custom">Ocupantes </span>
                {{ datosPoliza.INCISO[0].OCUPANTES }}
              </p>
            </div>
          </div>

          <div
            class="d-flex flex-wrap"
            v-if="typeEndoso !== 8 && typeEndoso !== 9"
          >
            <div class="col-md-12">
              <hr />
            </div>
          </div>

          <div
            class="d-flex flex-wrap mt-3"
            v-if="typeEndoso !== 8 && typeEndoso !== 9"
          >
            <div class="col-md-6">
              <p>
                <span class="title-custom">Forma de pago: </span>
                {{ datosPoliza.FORMAPAGO }}
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <span class="title-custom">Moneda: </span>
                {{ datosPoliza.MONEDA }}
              </p>
            </div>
          </div>

          <AumentoDeCoberturas
            v-if="typeEndoso === 8 || typeEndoso === 9"
            :datosPoliza="datosPoliza"
            :altaFolioInnova="altaFolioEndosoInnova"
            :typeEndoso="typeEndoso"
            :endosoCoberturas.sync="endosoCoberturas"
          />
          <CambioDeDescripcion
            v-if="typeEndoso === 12"
            :datosPoliza="datosPoliza"
            :descripcionVehiculo.sync="descripcionVehiculo"
            :altaFolioInnova="altaFolioEndosoInnova"
            :endosoCoberturas.sync="endosoCoberturas"
            :versionAuto.sync="versionAuto"
          />
          <!-- <DiminucionDeCoberturas
            v-if="typeEndoso === 9"
            :datosPoliza="datosPoliza"
            :altaFolioInnova="altaFolioEndosoInnova"
          /> -->
          <EquipoAdaptacion
            v-if="typeEndoso === 10"
            :datosCotizacion="datosCotizacion"
          />
          <FormaDePago
            v-if="typeEndoso === 11"
            :datosPoliza="datosPoliza"
            :altaFolioInnova="altaFolioEndosoInnova"
            :endosoCoberturas.sync="endosoCoberturas"
            :formaPago.sync="formaPago"
          />
          <Kilometraje
            v-if="typeEndoso === 7"
            :datosPoliza="datosPoliza"
            :kilometraje.sync="kilometraje"
            :altaFolioInnova="altaFolioEndosoInnova"
            :endosoCoberturas.sync="endosoCoberturas"
          />

          <BeneficiarioPreferente
            v-if="typeEndoso === 1"
            :nombreBeneficiario.sync="nombreBeneficiario"
            :altaFolioInnova="altaFolioEndosoInnova"
            :datosPoliza="datosPoliza"
          />
          <Contratante
            v-if="typeEndoso === 3"
            :datosPoliza="datosPoliza"
            :endoso.sync="endosoTres"
            :altaFolioInnova="altaFolioEndosoInnova"
          />
          <ModificacionDeDescripcion
            v-if="typeEndoso === 2"
            :datosPoliza="datosPoliza"
            :descripcionVehiculo.sync="descripcionVehiculo"
            :altaFolioInnova="altaFolioEndosoInnova"
            :endosoCoberturas.sync="endosoCoberturas"
          />
          <NumeroDeMotor
            v-if="typeEndoso === 4"
            :datosPoliza="datosPoliza"
            :numeroMotor.sync="motor"
            :altaFolioInnova="altaFolioEndosoInnova"
          />
          <NumeroDeSerie
            v-if="typeEndoso === 5"
            :datosPoliza="datosPoliza"
            :numeroSerie.sync="numeroSerie"
            :altaFolioInnova="altaFolioEndosoInnova"
          />
          <PlacasDeLaUnidad
            v-if="typeEndoso === 6"
            :datosPoliza="datosPoliza"
            :placas.sync="numeroPlacas"
            :altaFolioInnova="altaFolioEndosoInnova"
          />
        </div>
      </div>
    </section>

    <div
      class="modal fade"
      id="successEndoso"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              id="closesuccessEndoso"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="redirect()"
            ></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <p>
                  Endoso generado exitosamente.
                  <br />
                  {{ messageSuccessEndoso }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      id="successEndosoModal"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#successEndoso"
      style="display: none"
    >
      Modal Endoso
    </button>
  </div>
</template>

<style>
.title-custom {
  color: #003b71 !important;
  font-weight: bold !important;
  margin-left: 15px !important;
}

.label-custom {
  font-size: 12px !important;
  color: #757575 !important;
}

.label-custom-bold {
  font-size: 12px !important;
  color: #757575 !important;
  font-weight: bold !important;
}
</style>

<script>
import { validate } from "../../../../assets/helpers";
import moment from "moment";

import AumentoDeCoberturas from "../../tools/endosos/AumentoDeCoberturas.vue";
import CambioDeDescripcion from "../../tools/endosos/CambioDeDescripcion.vue";
import DiminucionDeCoberturas from "../../tools/endosos/DiminucionDeCoberturas.vue";
import EquipoAdaptacion from "../../tools/endosos/EquipoAdaptacion.vue";
import FormaDePago from "../../tools/endosos/FormaDePago.vue";
import Kilometraje from "../../tools/endosos/Kilometraje.vue";

import BeneficiarioPreferente from "../../tools/endosos/BeneficiarioPreferente.vue";
import Contratante from "../../tools/endosos/Contratante.vue";
import ModificacionDeDescripcion from "../../tools/endosos/ModificacionDeDescripcion.vue";
import NumeroDeMotor from "../../tools/endosos/NumeroDeMotor.vue";
import NumeroDeSerie from "../../tools/endosos/NumeroDeSerie.vue";
import PlacasDeLaUnidad from "../../tools/endosos/PlacasDeLaUnidad.vue";

export default {
  components: {
    AumentoDeCoberturas,
    CambioDeDescripcion,
    DiminucionDeCoberturas,
    EquipoAdaptacion,
    FormaDePago,
    Kilometraje,
    BeneficiarioPreferente,
    Contratante,
    ModificacionDeDescripcion,
    NumeroDeMotor,
    NumeroDeSerie,
    PlacasDeLaUnidad,
  },
  data() {
    return {
      idCotizacion: "",
      idPoliza: "",
      numeroSerie: "",
      emisionInicio: "",
      emisionFin: "",
      modelo: "",
      numeroPlacas: "",
      motor: "",
      vehiculo: "",
      controlVehicular: "",
      conductor: "",
      datosCotizacion: [],
      datosPoliza: [],
      messageSuccessEndoso: "",
      kilometraje: 0,
      typeEndoso: 0,
      ramo: "",
      inciso: "",
      folioInnova: "",
      idSolicitud: "",
      //Tipo Endoso 1
      nombreBeneficiario: "",
      descripcionVehiculo: "",
      //Tipo Endoso 3
      endosoTres: {
        nombre: "",
        rfc: "",
        situacionFiscal: "",
        fechaNacimiento: "",
        direccion: "",
        numExterior: "",
        numInterior: "",
        cp: "",
        colonia: "",
        municipio: "",
        estado: "",
        telefono: "",
        correo: "",
      },
      //Tipo Endoso 8 y 9
      endosoCoberturas: {
        periodo: "",
        duracion: "",
        primerRecibo: "",
        subsecuente: "",
        primaNeta: "",
        recargoFraccionado: "",
        gastosExpedicion: "",
        subtotal: "",
        iva: "",
        articulo101: "",
        ivaArticulo101: "",
        total: "",
      },
      formaPago: "",
      versionAuto: "",
      versionAutoDescripcion: "",
    };
  },
  methods: {
    formatInputDate(date, add) {
      const [day, month, year] = date.split("/");
      date = new Date(`${year}/${month}/${day}`);

      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    formatDateBirthday(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join("/");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    getCoberturas() {
      const cobsTemp = [];

      if (this.typeEndoso === 8 || this.typeEndoso === 9) {
        this.datosPoliza.INCISO[0].COBERTURASASEGURADAS.map((cob) => {
          cobsTemp.push({
            NOMENCLATURA: cob.NOMENCLATURA,
            DEDUCIBLE: cob.DEDUDEFAULT,
            PRIMA: cob.PRIMA,
            ORDEN: cob.ORDEN,
            DESCRIPCIONCOBERTURA: cob.DESCRIPCIONCOBERTURA,
            SUMA: cob.SUMADEFAULT,
          });
        });
      } else {
        this.datosPoliza.INCISO[0].COBERTURAS.map((cob) => {
          cobsTemp.push({
            NOMENCLATURA: cob.CLAVECOBERTURA,
            DEDUCIBLE: cob.DEDUCIBLE,
            PRIMA: cob.PRIMA,
            ORDEN: "",
            DESCRIPCIONCOBERTURA: cob.DESCRIPCION,
            SUMA: cob.SUMAASEGURADA,
          });
        });
      }

      return cobsTemp;
    },
    async cargarCotizacionDatos() {
      const payload = {
        metodo: "OBTIENEGUARDADOCOTIZACION",
        data: {
          CLIENTE: {},
          INCISOS: [
            {
              COBERTURAS: [{}],
            },
          ],
          COTIZACION: this.idCotizacion,
          POLIZA: this.idPoliza,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        if (response === "" || response.length <= 0) {
          let message = "";

          if (
            this.$store.getters.getDataRaw.errorMessage === "POLIZA CANCELADA"
          ) {
            message = "La poliza se encuentra cancelada";
          } else {
            message = "La poliza no existe";
          }

          this.$swal
            .fire({
              icon: "error",
              title: message,
              text: "Intentalo de nuevo con una poliza valida",
              allowOutsideClick: false,
              confirmButtonText: "Aceptar",
            })
            .then((result) => {
              if (result.isConfirmed) {
                window.location.href = `#/cotizador/auto/menu-endoso`;
                location.reload();
              }
            });
        } else {
          this.datosCotizacion = response[0];

          this.idPoliza = response[0].POLIZA;
          this.ramo = response[0].RAMO;
          this.inciso = response[0].INCISOS[0].INCISO;

          this.consultarPoliza(
            response[0].RAMO,
            response[0].POLIZA,
            response[0].INCISOS[0].INCISO
          );
        }
      }
    },
    async consultarPoliza(ramo, poliza, inciso) {
      const payload = {
        metodo: "CONSULTARPOLIZA",
        data: {
          RAMO: ramo,
          NumPoliza: poliza,
          NumInciso: inciso,
          TIPOENDOSO: this.getTipoEndoso(),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        this.datosPoliza = response[0];
        this.datosPoliza.INIVIGENCIA = moment(new Date()).format("DD/MM/YYYY");
        this.nombreBeneficiario = response[0].INCISO[0].BENEFICIARIO;
      }
    },
    async altaFolioEndosoInnova(file, endoso, tipoEndoso, comentario) {
      const payload = {
        metodo: "ALTAFOLIOENDOSOS",
        data: {
          RAMO: this.ramo,
          NumPoliza: this.idPoliza,
          NumInciso: this.inciso,
          Endoso: tipoEndoso,
          TipoMovimiento: endoso,
          Comentario: comentario,
          Anexos: [file],
          IdAgente: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        this.folioInnova = response.folio;
        this.idSolicitud = response.idSolicitud;
        this.guardarPolizaEdoso(tipoEndoso, endoso);
      }
    },
    async guardarPolizaEdoso(endoso, tipoEndoso) {
      const payload = {
        metodo: "GUARDARPOLIZAENDOSO",
        data: {
          AGENTE: localStorage.getItem("userId"),
          CLIENTE: {
            CORREO:
              this.endosoTres.correo !== ""
                ? this.endosoTres.correo
                : this.datosPoliza.ASEGURADO[0].CORREO,
            CP: "",
            FECHANACIMIENTO:
              this.endosoTres.fechaNacimiento !== ""
                ? this.endosoTres.fechaNacimiento
                : this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO,
            IDCLIENTE: this.datosPoliza.ASEGURADO[0].NUMEROCLIENTE,
            NOMBRE:
              this.endosoTres.nombre !== ""
                ? this.endosoTres.nombre
                : this.datosPoliza.ASEGURADO[0].NOMBRE,
            SEXO: this.datosPoliza.ASEGURADO[0].SEXO,
            TELEFONO:
              this.endosoTres.telefono !== ""
                ? this.endosoTres.telefono
                : this.datosPoliza.ASEGURADO[0].TELEFONO,
          },
          COTIZACION: "",
          ENDOSO: endoso,
          ENTIDAD: this.datosPoliza.ESTADOUNIVERSE,
          FECHAALTA: this.datosPoliza.INIVIGENCIA,
          FECHAINSPECION: "",
          FP:
            this.formaPago !== ""
              ? this.formaPago
              : this.datosPoliza.CVFORMAPAGO,
          GASTOS: this.endosoCoberturas.gastosExpedicion,
          INCISOS: [
            {
              CLAVE:
                this.versionAuto !== ""
                  ? this.versionAuto
                  : this.datosPoliza.INCISO[0].CVVEHICULO,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.datosPoliza.INCISO[0].CONDUCTOR,
              CONTROLVEHICULAR: "",
              KILOMETRAJE:
                this.kilometraje !== ""
                  ? this.kilometraje
                  : this.datosPoliza.INCISO[0].KILOMETRAJE,
              MODELO: this.datosPoliza.INCISO[0].MODELO,
              MOTOR: "",
              NUMEROINCISO: this.datosPoliza.INCISO[0].INCISO,
              PLACAS:
                this.numeroPlacas !== ""
                  ? this.numeroPlacas
                  : this.datosPoliza.INCISO[0].PLACA,
              SAVEHICULO: "0",
              SERIE: this.datosPoliza.INCISO[0].SERIE,
              SERVICIO: "",
              TIPOCARGA: "",
              TIPOPAQUETE: this.datosPoliza.INCISO[0].PAQUETE,
              USO: this.datosPoliza.INCISO[0].USO,
              VALORNUEVO: this.datosPoliza.VALORVEHICULO,
              FECHAFACTURA: "",
              FAMILIAR: {
                ALCALDIA: "",
                COLONIA: "",
                DIRECCION: "",
                ESTADO: "",
                EXTERIOR: "",
                INTERIOR: "",
                POSTAL: "",
              },
              BENEFICIARIO:
                this.nombreBeneficiario !== ""
                  ? this.nombreBeneficiario
                  : this.datosPoliza.INCISO[0].BENEFICIARIO,
            },
          ],
          IVA:
            this.endosoCoberturas.iva !== ""
              ? this.endosoCoberturas.iva
              : this.datosPoliza.IVA,
          MONEDA: this.datosPoliza.MONEDA,
          POLIZA: this.idPoliza,
          PRIMANETA:
            this.endosoCoberturas.primaNeta !== ""
              ? this.endosoCoberturas.primaNeta
              : this.datosPoliza.PRIMANETA,
          RAMO: this.datosPoliza.RAMO,
          RECARGOS:
            this.endosoCoberturas.recargoFraccionado !== ""
              ? this.endosoCoberturas.recargoFraccionado
              : this.datosPoliza.RECARGOS,
          SUBTOTAL:
            this.endosoCoberturas.subtotal !== ""
              ? this.endosoCoberturas.subtotal
              : this.datosPoliza.SUBTOTAL,
          SUMAASEGURADA: "",
          TIPO: this.datosPoliza.INCISO[0].TIPOVEHICULO,
          TOTAL:
            this.endosoCoberturas.total !== ""
              ? this.endosoCoberturas.total
              : this.datosPoliza.PRIMATOTAL,
          USUARIO: "",
          VIGENCIAFIN: this.datosPoliza.FINVIGENCIA,
          VIGENCIAINI: this.datosPoliza.INIVIGENCIA,
          TIPODOCUMENTO: 0,
          TIPOCOTIZADOR: 2,
          FOLIO: this.folioInnova,
          TIPOENDOSO: tipoEndoso,
          IDSOLICITUDINNOVA: this.idSolicitud,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const _ = this.$store.getters.getRespuestaREST;
        this.generarEndoso(endoso, tipoEndoso);
      }
    },
    async generarEndoso(endoso, tipoEndoso) {
      const payload = {
        metodo: "GUARDARENDOSO",
        data: {
          AGENTE: localStorage.getItem("userId"),
          ART: 0,
          ARTIVA: 0,
          CLIENTE: {
            CODIGOPOSTAL:
              this.endosoTres.cp !== ""
                ? this.endosoTres.cp
                : this.datosPoliza.ASEGURADO[0].CODIGOPOSTAL,
            COLONIA:
              this.endosoTres.colonia !== ""
                ? this.endosoTres.colonia
                : this.datosPoliza.ASEGURADO[0].COLONIA,
            CORREO:
              this.endosoTres.correo !== ""
                ? this.endosoTres.correo
                : this.datosPoliza.ASEGURADO[0].CORREO,
            DIRECCION:
              this.endosoTres.direccion !== ""
                ? this.endosoTres.direccion
                : this.datosPoliza.ASEGURADO[0].DIRECCION,
            ESTADO:
              this.endosoTres.estado !== ""
                ? this.endosoTres.estado
                : this.datosPoliza.ASEGURADO[0].ESTADO,
            FECHANACIMIENTO:
              this.endosoTres.fechaNacimiento !== ""
                ? this.endosoTres.fechaNacimiento
                : this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO,
            NOMBRE:
              this.endosoTres.nombre !== ""
                ? this.endosoTres.nombre
                : this.datosPoliza.ASEGURADO[0].NOMBRE,
            NUMEROCLIENTE: this.datosPoliza.ASEGURADO[0].NUMEROCLIENTE,
            POBLACION:
              this.endosoTres.municipio !== ""
                ? this.endosoTres.municipio
                : this.datosPoliza.ASEGURADO[0].POBLACION,
            RFC:
              this.endosoTres.rfc !== ""
                ? this.endosoTres.rfc
                : this.datosPoliza.ASEGURADO[0].RFC,
            SEXO: this.datosPoliza.ASEGURADO[0].SEXO,
            TELEFONO:
              this.endosoTres.telefono !== ""
                ? this.endosoTres.telefono
                : this.datosPoliza.ASEGURADO[0].TELEFONO,
          },
          COTIZACION: "",
          DURACION: this.endosoCoberturas.duracion,
          EMISION: this.datosPoliza.INIVIGENCIA,
          ENDOSO: endoso,
          ENTIDAD: this.datosPoliza.ESTADOUNIVERSE,
          FIN: this.datosPoliza.FINVIGENCIA,
          FP:
            this.formaPago !== ""
              ? this.formaPago
              : this.datosPoliza.CVFORMAPAGO,
          GASTOS: this.endosoCoberturas.gastosExpedicion,
          INCISOS: [
            {
              CLAVE:
                this.versionAuto !== ""
                  ? this.versionAuto
                  : this.datosPoliza.INCISO[0].CVVEHICULO,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.datosPoliza.INCISO[0].CONDUCTOR,
              BENEFICIARIO:
                this.nombreBeneficiario !== ""
                  ? this.nombreBeneficiario
                  : this.datosPoliza.INCISO[0].BENEFICIARIO,
              CONTROLVEHICULAR: "",
              DESCRIPVEH:
                this.descripcionVehiculo !== ""
                  ? this.descripcionVehiculo
                  : this.datosPoliza.INCISO[0].VEHICULO,
              FECHAFACTURA: "",
              FECHAINSPECCION: "",
              INCISO: this.datosPoliza.INCISO[0].INCISO,
              KILOMETRAJE:
                this.kilometraje !== 0
                  ? this.kilometraje
                  : this.datosPoliza.INCISO[0].KILOMETRAJE,
              MARCA: this.datosPoliza.INCISO[0].MARCA,
              MODELO: this.datosPoliza.INCISO[0].MODELO,
              MOTOR:
                this.motor !== ""
                  ? this.motor
                  : this.datosPoliza.INCISO[0].MOTOR,
              OCUPANTES: this.datosPoliza.INCISO[0].OCUPANTES,
              PLACAS:
                this.numeroPlacas !== ""
                  ? this.numeroPlacas
                  : this.datosPoliza.INCISO[0].PLACA,
              SERIE:
                this.numeroSerie !== ""
                  ? this.numeroSerie
                  : this.datosPoliza.INCISO[0].SERIE,
              SUBMARCA: this.datosPoliza.INCISO[0].SUBMARCA,
              TIPO: this.datosPoliza.INCISO[0].TIPOVEHICULO,
              TIPOPAQUETE: this.datosPoliza.INCISO[0].PAQUETE,
              USO: this.datosPoliza.INCISO[0].USO,
              VALORNUEVO: this.datosPoliza.VALORVEHICULO,
            },
          ],
          INICIO: this.datosPoliza.INIVIGENCIA,
          IVA:
            this.endosoCoberturas.iva !== ""
              ? this.endosoCoberturas.iva
              : this.datosPoliza.IVA,
          MONEDA: this.datosPoliza.MONEDA,
          NOMBREAGENTE: "",
          PAGO: this.datosPoliza.FORMAPAGO,
          POLIZA: this.idPoliza,
          PRIMANETA:
            this.endosoCoberturas.primaNeta !== ""
              ? this.endosoCoberturas.primaNeta
              : this.datosPoliza.PRIMANETA,
          PROMOTOR: this.datosPoliza.CVPROMOTOR,
          RAMO: this.datosPoliza.RAMO,
          RECARGOS:
            this.endosoCoberturas.recargoFraccionado !== ""
              ? this.endosoCoberturas.recargoFraccionado
              : this.datosPoliza.RECARGOS,
          RECIBO: [],
          RECIBO1: this.endosoCoberturas.primerRecibo,
          RECIBOSUB:
            this.endosoCoberturas.recargoFraccionado !== ""
              ? this.endosoCoberturas.recargoFraccionado
              : this.datosPoliza.RECARGOS,
          SUBTOTAL:
            this.endosoCoberturas.subtotal !== ""
              ? this.endosoCoberturas.subtotal
              : this.datosPoliza.SUBTOTAL,
          SUMAASEGURADA: "",
          TOTAL:
            this.endosoCoberturas.total !== ""
              ? this.endosoCoberturas.total
              : this.datosPoliza.PRIMATOTAL,
          FOLIOINNOVA: this.folioInnova,
          TIPOENDOSO: tipoEndoso,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);

      if (!this.$store.getters.getDataRaw.flag) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: this.$store.getters.getDataRaw.errorMessage,
        });
      }

      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        this.consultaFolioEndosoInnova(response.NUMERO_ENDOSO, tipoEndoso);
      }
    },
    async consultaFolioEndosoInnova(numeroEndoso, tipoEndoso) {
      const payload = {
        metodo: "CONSULTAFOLIOENDOSOINNOVA",
        data: {
          FolioInnova: this.folioInnova,
          IdSolicitud: this.idSolicitud,
          IdAgente: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);

      if (res) {
        const resp = this.$store.getters.getRespuestaREST;

        if (resp.ESTATUS === "Pendiente de Información") {
          this.terminaFolioEndosoInnova(numeroEndoso, tipoEndoso);
        } else {
          this.messageSuccessEndoso = `Tu numero de Endoso es: ${numeroEndoso}`;
          document.getElementById("successEndosoModal").click();
        }
      }
    },
    async terminaFolioEndosoInnova(endoso, tipo) {
      const payload = {
        metodo: "TERMINAFOLIOENDOSOS",
        data: {
          FolioInnova: this.folioInnova,
          IdSolicitud: this.idSolicitud,
          Endoso: tipo,
          IdAgente: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const _ = this.$store.getters.getRespuestaREST;
        this.messageSuccessEndoso = `Tu numero de Endoso es: ${endoso}`;
        document.getElementById("successEndosoModal").click();
      }
    },
    verifyIsEmpty(data) {
      return data !== null &&
        data !== "" &&
        data !== "NULL" &&
        data !== "null" &&
        data !== "Null"
        ? data
        : "";
    },
    redirect() {
      window.location.href = `#/cotizador/auto/cotizaciones-poliza`;
      location.reload();
    },
    validateStrings(e) {
      const target = String.fromCharCode(!e.charCode ? e.which : e.charCode);

      if (!validate.onlyNumbersLetters(target)) {
        e.preventDefault();
        return;
      }
    },
    getTipoEndoso() {
      switch (this.typeEndoso) {
        case 8:
          return "A1";
          break;
        case 9:
          return "D1";
        default:
          return "";
          break;
      }
    },
  },
  async mounted() {
    this.idPoliza = this.$route.query.idPoliza;
    this.typeEndoso = +this.$route.query.idTipo;

    if (this.idPoliza !== undefined && this.typeEndoso !== 0) {
      await this.cargarCotizacionDatos();
    }
  },
};
</script>
